export default __webpack_public_path__ + "static/tag-dont-5-dark-e028e84dfa7f60b7405cc64a6811ceff2b7f169cd1d0c7e9a5558d14036d8a08.png";